import { render, staticRenderFns } from "./SwitchPMR.vue?vue&type=template&id=5ef92986&"
import script from "./SwitchPMR.vue?vue&type=script&lang=js&"
export * from "./SwitchPMR.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPMR.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Flodging-filter&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports